<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h1 mat-dialog-title class="title">How do you want to group the date field?</h1>
<p class="fieldName">Field: {{ name }}</p>

<div mat-dialog-content>
  <form [formGroup]="editForm" class="form">
    <label>
      <input type="radio" value="D" formControlName="range" />
      <span>Day(s)</span>
    </label>
    <label>
      <input type="radio" value="M" formControlName="range" />
      <span>Month(s)</span>
    </label>
    <label>
      <input type="radio" value="Q" formControlName="range" />
      <span>Quarter(s)</span>
    </label>
    <label>
      <input type="radio" value="Y" formControlName="range" />
      <span>Year(s)</span>
    </label>
  </form>
</div>

<div mat-dialog-actions align="end" style="display: block">
  <button mat-button mat-dialog-close class="button_small cancel">
    cancel
  </button>
  <button mat-button class="button_small" (click)="apply()">apply</button>
</div>
